module.exports = __webpack_public_path__ + "img/logo-topdoctors-vertical.0091d349.svg";